import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { Flex } from "../../../components/Flex";
import { Text } from "../../../components/Text";
import { orgChatSliceSelectors } from "../../../redux/chat/orgChat.selector";
import { useAppSelector } from "../../../redux/store";
import { TestIDs } from "../../../tests/types/testIds";
import { Breakpoints } from "../../../theme/Breakpoints";
import { Spacing } from "../../../theme/Spacing";
import { WAUserAvatar } from "../../integration/components/whatsapp-chat/components/WAUserAvatar";

const Sidebar = styled(Flex)`
  width: 15rem;
  flex-shrink: 0;
  flex-direction: column;
  overflow-y: auto;
  background-color: ${({ theme }) => theme.white};
  border-inline-end: 1px solid ${({ theme }) => theme.darkSub};

  @media (max-width: ${Breakpoints.TABLET}) {
    display: none;
  }
`;

const MemberRow = styled(Flex)`
  align-items: center;
  gap: ${Spacing.s};
  padding: ${Spacing.s} ${Spacing.m};
`;

export const OrgChatMembers: React.FC = () => {
  const { t } = useTranslation();
  const members = useAppSelector(orgChatSliceSelectors.selectMembers);

  return (
    <Sidebar dataTestId={TestIDs.orgChat.members}>
      <Flex padding="m">
        <Text fontSize="m" fontWeight="bold">
          {t("teamChat.members.title", { total: members.length })}
        </Text>
      </Flex>

      {members.map((member) => (
        <MemberRow
          key={member._id}
          dataTestId={TestIDs.orgChat.member(member._id)}
        >
          <WAUserAvatar user={member} size="2rem" />

          <Flex flexDirection="column" minWidth="0">
            <Text fontSize="m" cutText>
              {member.name}
            </Text>
            {member.isOwner ? (
              <Text fontSize="xs" color="darkerSub">
                {t("teamChat.members.owner")}
              </Text>
            ) : null}
          </Flex>
        </MemberRow>
      ))}
    </Sidebar>
  );
};
